// extracted by mini-css-extract-plugin
module.exports = {"flag-link":"style_flag-link__3_jrK"};